
export const SCREEN_KEYS = {
  DASHBOARD: "dashboard",
  ASM_REPORT:"asmReport",
  MDC_REPORT:"mdcReport",
  STORE_REPORT:"storeReport",
  VARAINCE_REPORT:"varianceReport",
  STORE_ABSTRACT_REPORT:"storeAbstract",
  VISI_COOLER_IMAGE_REPORT: "visiCoolerImageReport",
  AVAILABILITY: "availability",
  COOLER_IMPURITY: "coolerImpurity",
  ACTIVATION: "activation",
  MODAL_RESULTS:"modalResults",
  DIS_REPORT: "disReport",
  VARIANCE_REPORT_AI_VS_MANUAL: "varianceReportAiVsManual",
  MASTER_SHEETS: "masterSheets",
};